import { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, UserRound } from "lucide-react";
import { useContent } from "../lib/content";
import { useAuth } from "../lib/auth";

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors ${isActive ? "text-[#C9A25E]" : "text-zinc-400 hover:text-white"}`;

export default function Navbar() {
  const { t } = useContent();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const main = [
    ["/carta", "carta", t("nav_carta", "Calculadora Gratis")],
    ["/solicitar", "solicitar", t("nav_solicitar", "Solicitar mi lectura")],
  ];
  const more = [
    ["/testimonios", "testimonios", "Testimonios"],
    ["/contacto", "contacto", t("nav_contacto", "Contacto")],
    ["/sobre-mi", "sobremi", "Sobre mí"],
  ];

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!menuRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const item = ([to, id, label], prefix) => (
    <NavLink key={id} to={to} data-testid={`${prefix}-${id}`} className={linkCls} onClick={() => setOpen(false)}>
      {label}
    </NavLink>
  );

  return (
    <nav data-testid="nav-bar" className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#06060C]/70 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <div data-testid="nav-moon-icon" className="h-9 w-9 rounded-full border border-[#C9A25E]/40 flex items-center justify-center text-[#C9A25E] text-lg">
            ☾
          </div>
          <div className="leading-none">
            <span className="font-display text-xl tracking-tight text-white block">{t("brand_name", "Etérea Enlace")}</span>
            <span className="text-[10px] tracking-[0.25em] uppercase text-zinc-500">{t("brand_tagline", "Astrología evolutiva")}</span>
          </div>
        </Link>
        <div className="hidden md:flex items-center gap-8">{main.map((l) => item(l, "nav"))}</div>
        <div ref={menuRef} className="relative flex items-center gap-4">
          <NavLink to={user ? "/mi-panel" : "/ingresar"} data-testid="nav-account"
            className={({ isActive }) => `hidden sm:inline-flex items-center gap-2 text-sm tracking-wide transition-colors ${isActive ? "text-[#C9A25E]" : "text-zinc-300 hover:text-[#C9A25E]"}`}>
            <UserRound size={16} /> {user ? "Mi panel" : "Mi cuenta · Entrar"}
          </NavLink>
          <Link to="/solicitar" data-testid="nav-cta" className="hidden sm:block">
            <span className="btn-lilac !py-2 !px-5 text-sm">{t("nav_cta", "Comenzar →")}</span>
          </Link>
          <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} aria-label="Menú"
            className="text-zinc-300 hover:text-[#C9A25E] p-1 transition-colors">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
          {open && (
            <div data-testid="nav-menu" className="absolute right-0 top-full mt-4 w-56 border border-white/10 bg-[#06060C]/95 backdrop-blur-xl px-6 py-5 flex flex-col gap-4 shadow-2xl">
              <div className="md:hidden flex flex-col gap-4 pb-4 border-b border-white/5">{main.map((l) => item(l, "nav-menu"))}</div>
              {more.map((l) => item(l, "nav"))}
              <NavLink to={user ? "/mi-panel" : "/ingresar"} data-testid="nav-menu-account" className={({ isActive }) => `sm:hidden ${linkCls({ isActive })}`} onClick={() => setOpen(false)}>
                {user ? "Mi panel" : "Mi cuenta · Entrar"}
              </NavLink>
              <NavLink to="/admin/login" data-testid="nav-admin" className="text-sm text-zinc-500 hover:text-[#C9A25E]" onClick={() => setOpen(false)}>
                Admin
              </NavLink>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
